import { render, staticRenderFns } from "./CacheReset.vue?vue&type=template&id=0dfdf910"
import script from "./CacheReset.vue?vue&type=script&lang=js"
export * from "./CacheReset.vue?vue&type=script&lang=js"
import style0 from "./CacheReset.vue?vue&type=style&index=0&id=0dfdf910&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports